// Layouts: the full horizontal bar (icon boxes joined by a line, label below) or the
// compact vertical rail of icon boxes with tooltips (the sticky side navigation).
export const STEPPER_VARIANT = {
    FULL: 'full',
    COMPACT: 'compact',
};

export const STEPPER_VARIANTS = new Set(Object.values(STEPPER_VARIANT));

// Visual state of one step relative to the active one.
export const STEPPER_STEP_STATE = {
    COMPLETED: 'completed',
    ACTIVE: 'active',
    UPCOMING: 'upcoming',
};

// Placeholder count when the skeleton has no step list to mirror yet.
export const STEPPER_SKELETON_DEFAULT_STEPS = 6;
